import type { FaireProductEntity } from "../../entity_types/product";

export const p_4e5tddz6tb: FaireProductEntity = {
  token: "p_4e5tddz6tb",
  type: "product",
  name: "Love to You Hearts Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/1550127dadf27e7084263e6a110f5f4053c5238c1293bd3b95db76618a38834c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5897a95f5419253aa89c02748f7a30eb601258f94016fb9fead02fabbe0c0b21.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:13.335Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
